module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Killing-Of-A-Sacred-Deer-The.ea1489c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Killing-Of-A-Sacred-Deer-The.jpg
// module id = lRG9
// module chunks = 0